import axios from 'axios';
import { decrypt, encrypt } from '../../util/Security';
import { statusCodeErrorMsg } from './StatusCodeErrorMessages';

const customAxios = axios.create();

customAxios.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response.status === 401) {
      window.localStorage.clear();
      window.location.href = '/';
      return { error: statusCodeErrorMsg[error.response.status] };
    } else {
      return { error: statusCodeErrorMsg[error.response.status] };
    }
  }
);

const API = `${process.env.REACT_APP_SERVER_API_URL}/odoo/candidate/`;

// GET
export const GET_METHOD = async (url, inputParams) => {
  let storage = decrypt(localStorage.getItem('login'));
  const headers = {
    'Content-Type': 'text/plain;charset=UTF-8',
  };

  const params = { ...inputParams, 'session-id': storage?.sessionId || '' };
  const encrypted = encrypt(params);
  let result = await customAxios.get(API + url, {
    headers,
    params: { query_params: encrypted },
  });
  if (result?.data) result = { ...result, data: decrypt(result.data) };
  return result;
};

// POST
export const POST_METHOD = async (url, inputParams, config) => {
  let storage = decrypt(localStorage.getItem('login'));
  const configuration = {
    ...config,
    headers: {
      'Content-Type': 'text/plain;',
    },
  };

  const params = { ...inputParams, 'session-id': storage?.sessionId || '' };
  const encrypted = encrypt(params);

  try {
    let result = await customAxios.post(API + url, encrypted, configuration);
    if (result?.data) result = { ...result, data: decrypt(result.data) };
    return result;
  } catch (error) {
    return error;
  }
};
